import {
  AfterContentInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Injector,
  forwardRef,
  inject,
  input,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgClass } from '@angular/common';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { BaseControlValueAccessor } from '../base-control-value-accessor';

// Not used yet. Delete if nothing ends up needing it.
// A question row with Yes/No pill toggles. Value is boolean, null until answered.
@Component({
  selector: 'lib-form-yes-no',
  templateUrl: './form-yes-no.component.html',
  styleUrl: './form-yes-no.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => FormYesNoComponent), multi: true },
  ],
})
export class FormYesNoComponent
  extends BaseControlValueAccessor<boolean | null>
  implements AfterContentInit, ControlValueAccessor
{
  private static nextId = 0;
  private injector = inject(Injector);
  private cdRef = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  readonly inputId = `form-yes-no-${FormYesNoComponent.nextId++}`;
  label = input.required<string>();
  yesText = input<string>('Yes');
  noText = input<string>('No');

  ngAfterContentInit(): void {
    const ngControl = this.injector.get(NgControl, null);
    this.control = (ngControl?.control as FormControl) ?? new FormControl();
    // No mat-form-field here to re-render on touch, so watch the control ourselves.
    this.control.events
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.cdRef.markForCheck());
  }

  override writeValue(value: boolean | null): void {
    this.value = value;
    this.cdRef.markForCheck();
  }

  select(value: boolean): void {
    if (this.disabled) return;
    this.value = value;
    this.onChange(value);
    this.onTouched();
  }

  protected override getLabel(): string {
    return this.label();
  }

  // The label is the whole question, so "<question> is required" reads badly.
  override getErrorMessage(errorKey: string): string {
    return errorKey === 'required' ? 'Please answer Yes or No' : super.getErrorMessage(errorKey);
  }
}
